<div class="mt-8 mb-6">
  <h4 i18n="@@translateApp_plugins_title">Plugin titles</h4>
</div>
<form>
  <div class="grid grid-cols-2 gap-6 mb-4" [formGroup]="pluginsArray"
    *ngFor="let plugin of appPlugins; let i=index">
    <xena-input [value]="appPlugins[i].title" tabindex="-1" readonly></xena-input>
    <xena-input [formControlName]="i" *ngIf="cultureSelected" [readonly]="isReadonly"></xena-input>
  </div>
</form>
